import { mapGetters } from 'vuex'
export default {
    name: 'PointsStatement',
    data () {
      return {
        earnedPoints: null,
        redeemable_points: undefined
      }
    },
    computed:{
      ...mapGetters([
        "getloyaltypoints",
        "user"
      ])
    },
    methods: {
      //var epp = getloyaltypoints.point
    },
    mounted(){
      this.$store.dispatch("getloyaltypoints")
    }
}


// WEBPACK FOOTER //
// ./src/components/EplNewPointsStatement/component.js